// Weldingmen Offroad - theme.js
// Vanilla JS. No build step. Handles: mobile menu, variant picker,
// cart drawer + AJAX add, qty stepper, configurator chips.

(function () {
  'use strict';

  // ============================================================
  // MOBILE NAV
  // ============================================================
  const header = document.getElementById('site-header');
  if (header) {
    const burger = header.querySelector('.wmo-header__burger');
    if (burger) {
      burger.addEventListener('click', () => {
        const open = header.getAttribute('data-menu-open') === 'true';
        header.setAttribute('data-menu-open', open ? 'false' : 'true');
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
        burger.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
        document.body.style.overflow = open ? '' : 'hidden';
      });
    }
    header.querySelectorAll('.wmo-header__navlist a').forEach((a) => {
      a.addEventListener('click', () => {
        if (header.getAttribute('data-menu-open') === 'true') {
          header.setAttribute('data-menu-open', 'false');
          const b = header.querySelector('.wmo-header__burger');
          if (b) {
            b.setAttribute('aria-expanded', 'false');
            b.setAttribute('aria-label', 'Open menu');
          }
          document.body.style.overflow = '';
        }
      });
    });
  }

  // ============================================================
  // VARIANT PICKER (button-based)
  // ============================================================
  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const productData = JSON.parse(picker.dataset.product || '{}');
    const variants = productData.variants || [];
    const priceEl = document.querySelector('[data-pdp-price]');
    const stockEl = document.querySelector('[data-pdp-stock]');
    const submitEl = document.querySelector('[data-pdp-submit]');
    const idInput = picker.parentElement.querySelector('input[name="id"]');

    function findVariant() {
      const selected = {};
      picker.querySelectorAll('[data-option-row]').forEach((row) => {
        const idx = parseInt(row.dataset.optionRow, 10);
        const active = row.querySelector('[aria-pressed="true"]');
        if (active) selected[idx] = active.dataset.optionValue;
      });
      return variants.find((v) => {
        return v.options.every((opt, i) => selected[i + 1] === undefined || selected[i + 1] === opt);
      });
    }

    function update() {
      const v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (stockEl) {
        stockEl.textContent = v.available
          ? '● IN STOCK · SHIPS IN 2 BUSINESS DAYS'
          : '○ CURRENTLY OUT OF STOCK';
        stockEl.classList.toggle('wmo-pdp__chip--stock', v.available);
        stockEl.classList.toggle('wmo-pdp__chip--oos', !v.available);
      }
      if (submitEl) {
        submitEl.disabled = !v.available;
        const labelSpan = submitEl.querySelector('[data-submit-label]');
        if (labelSpan) labelSpan.textContent = v.available ? 'Add to Cart' : 'Sold out';
      }
    }

    picker.querySelectorAll('.wmo-variant__opt').forEach((opt) => {
      opt.addEventListener('click', () => {
        const row = opt.closest('[data-option-row]');
        row.querySelectorAll('.wmo-variant__opt').forEach((o) => o.setAttribute('aria-pressed', 'false'));
        opt.setAttribute('aria-pressed', 'true');
        update();
      });
    });
  });

  // ============================================================
  // ADD TO CART (AJAX) + CART DRAWER
  // ============================================================
  const drawer = document.querySelector('[data-cart-drawer]');
  const cartCount = document.querySelector('.wmo-header__cart-count');

  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js');
      const c = await r.json();
      if (cartCount) cartCount.textContent = c.item_count;
    } catch (e) { /* swallow */ }
  }

  function openDrawer() {
    if (!drawer) {
      window.location = '/cart';
      return;
    }
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (drawer) {
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach((b) => b.addEventListener('click', closeDrawer));
    drawer.querySelector('[data-cart-drawer-scrim]')?.addEventListener('click', closeDrawer);
  }

  document.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submit = form.querySelector('[data-pdp-submit]');
      const orig = submit ? submit.innerHTML : '';
      if (submit) {
        submit.disabled = true;
        submit.innerHTML = 'Adding...';
      }
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
        if (!r.ok) throw new Error('cart add failed');
        await refreshCartCount();
        if (drawer) {
          // Refresh drawer content
          const dr = await fetch(window.location.pathname + '?section_id=cart-drawer');
          if (dr.ok) {
            const html = await dr.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newDrawerBody = doc.querySelector('[data-cart-drawer-body]');
            const oldDrawerBody = drawer.querySelector('[data-cart-drawer-body]');
            if (newDrawerBody && oldDrawerBody) oldDrawerBody.innerHTML = newDrawerBody.innerHTML;
          }
          openDrawer();
        } else {
          window.location = '/cart';
        }
      } catch (err) {
        alert('Could not add to cart. Please try again.');
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.innerHTML = orig;
        }
      }
    });
  });

  document.querySelectorAll('[data-cart-open]').forEach((b) => {
    b.addEventListener('click', (e) => {
      if (drawer) {
        e.preventDefault();
        openDrawer();
      }
    });
  });

  // ============================================================
  // CART QTY STEPPERS + REMOVE (cart page)
  // ============================================================
  document.addEventListener('click', async (e) => {
    const stepper = e.target.closest('[data-cart-qty]');
    const remove = e.target.closest('[data-cart-remove]');
    if (stepper) {
      const line = stepper.dataset.line;
      const change = parseInt(stepper.dataset.change, 10);
      const input = stepper.parentElement.querySelector('input');
      const newQty = Math.max(0, (parseInt(input.value, 10) || 0) + change);
      input.value = newQty;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: newQty }),
      });
      window.location.reload();
    }
    if (remove) {
      e.preventDefault();
      const line = remove.dataset.line;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: 0 }),
      });
      window.location.reload();
    }
  });

  // ============================================================
  // PDP GALLERY - main image swap, arrows, thumbs, keyboard, swipe
  // ============================================================
  document.querySelectorAll('[data-gallery]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('[data-slide-index]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    const counterEl = root.querySelector('[data-gallery-current]');
    const main = root.querySelector('[data-gallery-main]');
    const total = slides.length;
    if (total <= 1) return;
    let current = 0;

    function show(idx) {
      idx = ((idx % total) + total) % total;
      slides.forEach((s, i) => {
        const active = i === idx;
        s.classList.toggle('is-active', active);
        if (active) { s.removeAttribute('hidden'); } else { s.setAttribute('hidden', ''); }
      });
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      if (counterEl) counterEl.textContent = idx + 1;
      const activeThumb = thumbs[idx];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      current = idx;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => show(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(current + 1));
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));

    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
    });

    if (main) {
      let startX = 0, startY = 0, tracking = false;
      main.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          show(dx > 0 ? current - 1 : current + 1);
        }
      });
    }
  });

  // ============================================================
  // CONFIGURATOR (QUOTE form) - chip toggles
  // ============================================================
  document.querySelectorAll('[data-chip-toggle]').forEach((chip) => {
    chip.addEventListener('click', () => {
      const row = chip.closest('[data-chip-row]');
      const multi = row && row.dataset.chipRow === 'multi';
      if (!multi) {
        row.querySelectorAll('[data-chip-toggle]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
      }
      const cur = chip.getAttribute('aria-pressed') === 'true';
      chip.setAttribute('aria-pressed', cur ? 'false' : 'true');
      const hidden = row.querySelector('input[type="hidden"]');
      if (hidden) {
        const selected = Array.from(row.querySelectorAll('[aria-pressed="true"]')).map((c) => c.dataset.chipValue);
        hidden.value = selected.join(', ');
      }
    });
  });

  // ============================================================
  // CONTACT FORM - prefill from ?product= URL param
  // Enquire-to-Buy on PDPs sends customers to /pages/contact?product=X
  // ============================================================
  const contactMsg = document.getElementById('contact-message');
  if (contactMsg) {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    if (product) {
      const prefill = 'Enquiry about: ' + product + '\n\n';
      if (!contactMsg.value) {
        contactMsg.value = prefill;
        setTimeout(function() {
          contactMsg.focus();
          contactMsg.setSelectionRange(contactMsg.value.length, contactMsg.value.length);
        }, 0);
      }
      const purpose = document.getElementById('contact-purpose');
      if (purpose) {
        const p = product.toLowerCase();
        let target = 'Tray or canopy build quote';
        if (!p.includes('tray') && !p.includes('canopy') && !p.includes('1850')) {
          target = 'Accessory order or fitment';
        }
        for (let i = 0; i < purpose.options.length; i++) {
          if (purpose.options[i].text === target) {
            purpose.selectedIndex = i;
            break;
          }
        }
      }
    }
  }
})();
